import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Link from '../../components/Link';

const KycLink = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Link mt={16} textAlign="left" onClick={onClick} title={t('dolater')} />
  );
};

KycLink.propTypes = {
  onClick: PropTypes.string,
};

export default KycLink;
